<template>
  <div>
    <div class="bg-secondary rounded max-w-400">
      <div class="flex h-339 justify-center items-center">
        <div class="border border-default rounded px-30 py-50">
          <div class="w-full h-full relative">
            <div class="flex items-center gap-20">
              <router-link to="Login">
                <back-arrow  class="right-back-arrow" />
              </router-link>
              <div class="w-full">
                <div class="card-subtitle">
                  {{ $t('reset_password') }}
                </div>
              </div>
            </div>
            <form class="mt-36" action="submit" @submit.prevent="resetPasswordHandler()">
              <div>
                <BasePasswordMeter
                  class="mb-20"
                  v-model="newPassword"
                  shouldValidate
                  id="new_password"
                  :placeholder="$t('new_password')"
                  shouldFocus
                />
                <BasePasswordMeter
                  v-model="confirmPassword"
                  shouldValidate
                  id="confirm_password"
                  :placeholder="$t('repeat_password')"
                />
              </div>
              <div class="mt-20">
                <!-- Base button starts -->
                <base-button
                  width="318"
                  height="48"
                  :disabled="!(confirmPassword.length && newPassword.length)"
                  buttonType="primary"
                  radius="sm"
                  type="submit"
                >
                  <template #icon v-if="loading">
                    <div class="w-18 h-18">
                      <base-loading size="full" borderWidth="2" />
                    </div>
                  </template>
                  <template #text v-else> {{ $t('reset_password') }} </template>
                </base-button>
                <!-- Base button ends -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import BasePasswordMeter from '@/components/base/BasePasswordMeter.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import BackArrow from '@/assets/icons/vue/backArrow.vue';

export default {
  name: 'ForgerPassword',
  components: {
    BasePasswordMeter,
    BaseLoading,
    BaseButton,
    BackArrow,
  },
  mounted() {
    if (!this.$store.state.authentication.mobileNumber) {
      this.$router.push({ name: 'Login', params: { locale: localStorage.locale } });
    }
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading.loadingButton;
    },
  },
  methods: {
    resetPasswordHandler() {
      this.$store.commit('loading/LOADING_HANDLER', true);
      const { newPassword, confirmPassword } = this;
      this.$store
        .dispatch('authentication/resetPassword', {
          newPassword,
          confirmPassword,
        })
        .then(() => {
          this.$store.commit('loading/LOADING_HANDLER', false);
          this.$toast.success(this.$t('password_changed'));
          if (localStorage.token) {
            this.$router.push({ name: 'EditProfile', params: { locale: localStorage.locale } });
          } else {
            this.$router.push({ name: 'Verify', params: { loginMethod: 'password' } });
          }
        })
        .catch((error) => {
          this.$store.commit('loading/LOADING_HANDLER', false);
          serverErrorsHandler(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
